module.exports = __webpack_public_path__ + "zvetseni-prsou_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_2_after.jpg
// module id = 1323
// module chunks = 0